import { useForm } from 'react-hook-form'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'libs/router'
import { useTranslation } from 'libs/i18n'
import { LanguageSwitcher, Button } from 'shared/components'
import { useLoginValidationSchema } from './hooks/useLoginValidationSchema'
import { InputGroup } from 'shared/molecules'
import { useLoginMutation } from './mutations/useLoginMutation'
import { Logo } from 'shared/atoms'

const LoginPage = () => {
	const { t } = useTranslation()
	const validationResolver = useLoginValidationSchema()

	const {
		register,
		handleSubmit,
		setError,
		formState: { errors }
	} = useForm({
		resolver: validationResolver,
		mode: 'onChange'
	})

	const { loginMutation, loadingLogin } = useLoginMutation(setError)

	const onSubmit = (data: any) => {
		loginMutation(data)
	}

	return (
		<section className="flex min-h-screen items-center justify-center p-4">
			<form
				className="w-full max-w-[362px] rounded-lg px-6 py-7 shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
				onSubmit={handleSubmit(onSubmit)}>
				<div className="flex justify-end text-sm text-doveGray">
					<LanguageSwitcher />
				</div>
				<Logo className="my-5 max-h-[100px]" />
				<div className="mb-6">
					<h1 className="text-base font-semibold text-scorpion">{t('Login')}</h1>
				</div>
				<div className="flex flex-col gap-2">
					<InputGroup
						id="email"
						label={t('Email')}
						{...register('email')}
						error={(errors as any).email}
					/>
					<InputGroup
						id="password"
						label={t('Password')}
						type="password"
						{...register('password')}
						error={(errors as any).password}
					/>
					<Link to="/password-reset" className="self-end text-xs font-bold text-accent">
						{t('Reset password')}
					</Link>
				</div>
				<Button
					type="submit"
					icon={faArrowRight}
					isLoading={loadingLogin}
					className="mt-8 block w-full bg-emperor py-2.5 font-black text-white">
					{t('Sign in')}
				</Button>
				<a
					href="https://smartgo.is"
					target="_blank"
					rel="noreferrer"
					className="mt-5 block text-center text-xs">
					{t('Powered by Smartgo')}
				</a>
			</form>
		</section>
	)
}

export default LoginPage
